import { generatePath } from '@toggle/helpers';
import { ThemeSchemaResponse } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { SectionTitle } from '~/components/section-title/SectionTitle';
import { TeamsGuard } from '~/config/TeamsGuard';
import { appPaths } from '~/routes/app-paths';
import { queryKeys } from '~/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import sharedStyles from '../theme-knowledge-graph/LegacyThemeKnowledgeGraph.module.scss';

const THEME_COMPETITOR_OVERVIEW = 'overview';

export const CompetingThemes = ({
  competingThemes,
  limit = 3,
}: {
  competingThemes: ThemeSchemaResponse[];
  limit?: number;
}) => {
  const { t } = useTranslation(['widget']);
  const navigate = useNavigate();
  const { trackThemeOpen } = usePosthogEvents();

  if (!competingThemes.length) {
    return null;
  }

  return (
    <div>
      <SectionTitle
        title={t(
          'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.competingThemes'
        )}
        variant="small"
      />
      <TeamsGuard>
        <div>
        {competingThemes.slice(0, limit).map((t: ThemeSchemaResponse) => (
          <div
            className={sharedStyles.themeRow}
            data-theme-row
            onClick={() => {
              trackThemeOpen(POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW);
              navigate(
                generatePath({
                  basePath: `${appPaths.themeOverview}/${t.id}`,
                  params: {
                    [queryKeys.activeSubTab]: THEME_COMPETITOR_OVERVIEW,
                  },
                })
              );
            }}
            key={t.name}
          >
            <div className={sharedStyles.themeNameWrapper}>
              <ThemeLogoIcon
                name={t.name}
                logo_url={t.logo_url}
                fallbackIcon={
                  <div className={sharedStyles.logoWrapper}>
                    {t.name.charAt(0)}
                  </div>
                }
              />
              <span className={sharedStyles.themeName}>{t.name}</span>
            </div>
          </div>
        ))}
        </div>
      </TeamsGuard>
    </div>
  );
};
